import React from 'react';
import VetCheckDatePicker from '../../components/datePicker/VetCheckDatePicker';
import DocumentUpload from '../media/DocumentUpload';
import HealthDocumentGallery from '../media/HealthDocumentGallery';


export default function Step3Health({ formData, onNext, onBack, onChange, dropdowns }) {
  const handleInput = (e) => {
    const { name, value } = e.target;
    const [parent, field] = name.split('.');
    if (parent === 'healthInfo') {
      onChange({
        horseInfo: {
          ...formData.horseInfo,
          healthInfo: {
            ...formData.horseInfo?.healthInfo,
            [field]: value
          }
        }
      });
    }
  };

  const handleVetCheckChange = (updatedFields) => {
    onChange({
      horseInfo: {
        ...formData.horseInfo,
        healthInfo: {
          ...formData.horseInfo?.healthInfo,
          ...updatedFields
        }
      }
    });
  };

  const handleDocumentUpload = (url, publicId) => {
    onChange({
      documents: [
        ...(formData.documents || []),
        { url, public_id: publicId, tag: 'medical' }
      ]
    });
  };

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold mb-4">Health & History</h2>

      {/* Health Status */}
      <div>
        <label className="block text-sm font-bold">Health Status</label>
        <select
          name="healthInfo.status"
          value={formData.horseInfo?.healthInfo?.status || ''}
          onChange={handleInput}
          className="w-full border rounded px-3 py-2"
        >
          <option value="">Select</option>
          {dropdowns.healthStatus?.map((status) => (
            <option key={status} value={status}>{status}</option>
          ))}
        </select>
      </div>

      {/* Vet Check Date Picker */}
      <div>
        <label className="text-sm font-bold mb-1">Last Vet Visit</label>
        <VetCheckDatePicker
          value={formData.horseInfo?.healthInfo?.vetCheckDate}
          isNA={formData.horseInfo?.healthInfo?.vetCheckNA}
          explanation={formData.horseInfo?.healthInfo?.vetCheckExplanation}
          onChange={handleVetCheckChange}
        />
      </div>

      {/* Known Issues */}
      <div>
        <label className="block text-sm font-bold mb-1">Known Issues or Previous Injuries</label>
        <textarea
          name="healthInfo.knownIssues"
          value={formData.horseInfo?.healthInfo?.knownIssues || ''}
          onChange={handleInput}
          className="w-full border rounded px-3 py-2"
        />
      </div>
    
    {/* Medical Document Upload */}
      <div>
        <h2 className="text-xl font-bold mb-4">Upload Health Related Documents</h2>
        <DocumentUpload
          tag="medical"
          onUploadComplete={(url, publicId) => {
            onChange({
              documents: [
                ...(formData.documents || []),
                { url, public_id: publicId, tag: 'medical' }
              ]
            });
          }}
        />
      </div>

      {formData.documents?.filter(doc => doc.tag === 'medical')?.length > 0 && (
        <HealthDocumentGallery
          documents={formData.documents.filter(doc => doc.tag === 'medical')}
          onRemove={(indexToRemove) => {
            const updatedDocs = formData.documents.filter((doc, idx) => !(doc.tag === 'medical' && idx === indexToRemove));
            onChange({ documents: updatedDocs });
          }}
        />
      )}

      {/* Navigation */}
      <div className="flex justify-between mt-8">
        <button onClick={onBack} className="bg-gray-300 text-black py-2 px-6 rounded">Back</button>
        <button onClick={onNext} className="bg-primary text-white py-2 px-6 rounded hover:bg-primary-dark">Next</button>
      </div>
    </div>
  );
}